import imageUrlBuilder from '@sanity/image-url';
import { $globalSanityClient } from './$globalSanityClient';

const builder = imageUrlBuilder($globalSanityClient);

export default builder;
